"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/PartyPopper` instead */
export const PartyPopper = createSVGIcon(
  <>
    <path
      d="m3.682 22.629 11.452-4.257a2.153 2.153 0 0 0 .831-3.516l-7.2-7.2a2.153 2.153 0 0 0-3.516.831L.993 19.94a2.074 2.074 0 0 0 2.69 2.69ZM20.486 12.218a3.6 3.6 0 0 0-2.505-.357M16.582 7.335a3.6 3.6 0 0 0 .515-2.477M12.641 1.236a8.07 8.07 0 0 1-.233 5.674"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.143 5.621a.857.857 0 1 1-1.715 0 .857.857 0 0 1 1.715 0Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "PartyPopper",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
